import axios from "axios";

export default {
  async getFile(url) {
    return await axios({
      method: 'GET',
      url: url,
      baseURL: null,
      responseType: 'blob'
    })
      .then(response => {
        const blob = new Blob([response.data], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });

        return {
          success: true,
          blob
        };
      })
      .catch((error) => {
        return Promise.reject(error.response);
      })
  },
  async getFileStream(url) {
    return await axios({
      method: 'GET',
      url: url,
      baseURL: null,
      responseType: 'stream'
    })
      .then(response => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error.response);
      })
  },
  async sendFile(endpoint, data, progressFunc,userId) {

    //const token = localStorage.getItem('token')
    const progressConfig = {
      onUploadProgress: progressFunc ?? (() => {}),
      headers: {
        userid: userId
      },
    };
    const url = process.env.VUE_APP_EPD_BASE_URL || 'https://livestock-epd-nodeapi-dev.dimitra.dev';

    return await axios.post(
      `${url}/bulkUpload`, 
      data, 
      progressConfig)
      .then(({ data }) => data)
      .catch(error => Promise.reject(error));
  }
}
